import React from 'react';
import { BodyTextTW } from '../bodyText/BodyTextTW';

export interface ProgressBarTWProps {
  percentage: number;
  label?: string;
}

export const ProgressBarTW = ({ percentage, label }: ProgressBarTWProps) => {
  return (
    <div className={'w-full'}>
      <div className={`h-4 w-full rounded-sm bg-gray-200`}>
        <div
          className={`h-4 rounded-sm bg-foundation-zillowBlue`}
          data-test-id={'progress-bar-current'}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      {label && (
        <div className={'flex flex-row-reverse'}>
          <BodyTextTW className={'text-foundation-coolGray'}>{label}</BodyTextTW>
        </div>
      )}
    </div>
  );
};
